import '../css/home.scss'

export default function Home()
{
  return (
    <div className="pane">
        Future home of <span className="url-span">ForePlayGolfSim.com</span>
    </div>
  );
}